export default __webpack_public_path__ + "5a455580492b9b89dda5fe8b0a9a16fb.png";